<template>
    <div class="user-component">
        <div class="user-body">
            <b-form data-vv-scope="user-form">
                <b-form-group
                    label="Username"
                    label-for="username"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="user-username"
                        name="username"
                        data-vv-as="Username"
                        v-model="user_form.username"
                        type="text"
                        placeholder="Username"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('user-form.username') }">{{ errors.first('user-form.username') }}</span>
                </b-form-group>
                <b-form-group
                    label="Nama Lengkap"
                    label-for="full_name"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="user-full_name"
                        name="full_name"
                        data-vv-as="Nama Lengkap"
                        v-model="user_form.full_name"
                        type="text"
                        placeholder="Nama Lengkap"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('user-form.full_name') }">{{ errors.first('user-form.full_name') }}</span>
                </b-form-group>
                <b-form-group
                    label="Email"
                    label-for="email"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="user-email"
                        name="email"
                        data-vv-as="Email"
                        v-model="user_form.email"
                        type="email"
                        placeholder="Email"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('user-form.email') }">{{ errors.first('user-form.email') }}</span>
                </b-form-group>
                <b-form-group
                    label="Jenis Kelamin"
                    label-for="gender"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-select
                        v-model="user_form.gender"
                        name="gender"
                        value-field="id"
                        text-field="name"
                        data-vv-as="Jenis Kelamin"
                        :options="genderList"
                        v-validate="'required'"
                    ></b-form-select>
                    <span :class="{ 'error-validation': errors.first('user-form.gender') }">{{ errors.first('user-form.gender') }}</span>
                </b-form-group>
                <b-form-group
                    label="Type"
                    label-for="type"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-select
                        v-model="user_form.type"
                        name="type"
                        data-vv-as="Type"
                        value-field="id"
                        text-field="name"
                        :options="userTypeList"
                        v-validate="'required'"
                    >
                    <b-form-select-option :value="null" disabled>Pilih Tipe</b-form-select-option>
                    </b-form-select>
                    <span :class="{ 'error-validation': errors.first('user-form.type') }">{{ errors.first('user-form.type') }}</span>
                </b-form-group>
                <b-form-group
                    label="Tempat Lahir"
                    label-for="place_of_birth"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="user-place_of_birth"
                        name="place_of_birth"
                        data-vv-as="Tempat Lahir"
                        v-model="user_form.place_of_birth"
                        type="text"
                        placeholder="Tempat Lahir"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="date_of_birth"
                    label="Tanggal Lahir"
                    label-cols-sm="3"
                >
                    <b-form-datepicker
                        id="user-date_of_birth"
                        v-model="user_form.date_of_birth"
                        name="date_of_birth"
                        show-decade-nav="true"
                        data-vv-as="Tanggal Lahir"
                        class="mb-2"
                    ></b-form-datepicker>
                </b-form-group>
                <b-form-group
                    id="no_induk"
                    label="Nomor Induk"
                    label-cols-sm="3"
                >
                    <b-form-input
                        id="user-no_induk"
                        class="form-profil"
                        name="no_induk"
                        data-vv-as="Nomor Induk"
                        v-model="user_form.no_induk"
                        type="text"
                        placeholder="Nomor Induk"
                        trim
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="nis_nas"
                    label="Nomor Induk Siswa Nasional"
                    label-cols-sm="3"
                >
                    <b-form-input
                        id="user-nis_nas"
                        class="form-profil"
                        name="nis_nas"
                        data-vv-as="Nomor Induk Siswa Nasional"
                        v-model="user_form.nis_nas"
                        type="text"
                        placeholder="Nomor Induk Siswa Nasional"
                        trim
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="parent_name"
                    label="Nama Orang Tua"
                    label-cols-sm="3"
                >
                    <b-form-input
                        id="user-parent_name"
                        class="form-profil"
                        name="parent_name"
                        data-vv-as="Nama Orang Tua"
                        v-model="user_form.parent_name"
                        type="text"
                        placeholder="Nama Orang Tua"
                        trim
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="address"
                    label="Alamat Lengkap"
                    label-cols-sm="3"
                >
                    <b-form-textarea
                        id="user-address"
                        class="form-profil"
                        name="address"
                        data-vv-as="Alamat Lengkap"
                        v-model="user_form.address"
                        placeholder="Alamat Lengkap"
                        rows="3"
                        max-rows="6"
                        autocomplete="off"
                    ></b-form-textarea>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveData">SIMPAN</b-button>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            id: {
                type: String,
                default: null
            },
            genderList: {
                type: Array,
                default () {
                    return [{}]
                }
            },
            userTypeList: {
                type: Array,
                default () {
                    return [{}]
                }
            },
            detail: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                user_form: {
                    username : this.id ? this.detail.username: null,
                    full_name : this.id ? this.detail.full_name: null,
                    email : this.id ? this.detail.email: null,
                    gender : this.id ? this.detail.gender: null,
                    type : this.id ? this.detail.type: null,
                    address : this.id ? this.detail.address: null,
                    date_of_birth : this.id ? this.detail.date_of_birth: null,
                    nis_nas : this.id ? this.detail.nis_nas: null,
                    no_induk : this.id ? this.detail.no_induk: null,
                    parent_name : this.id ? this.detail.parent_name: null,
                    place_of_birth : this.id ? this.detail.place_of_birth: null,
                },
            };
        },
        methods: {
            resetForm() {
                this.user_form.username = this.id ? this.detail.username : null,
                this.user_form.full_name = this.id ? this.detail.full_name : null,
                this.user_form.email = this.id ? this.detail.email : null,
                this.user_form.gender = this.id ? this.detail.gender : null,
                this.user_form.type = this.id ? this.detail.type : null,
                this.user_form.address = this.id ? this.detail.address : null,
                this.user_form.date_of_birth = this.id ? this.detail.date_of_birth : null,
                this.user_form.nis_nas = this.id ? this.detail.nis_nas : null,
                this.user_form.no_induk = this.id ? this.detail.no_induk : null,
                this.user_form.parent_name = this.id ? this.detail.parent_name : null,
                this.user_form.place_of_birth = this.id ? this.detail.place_of_birth : null,
                this.$validator.reset()
            },
            hideFormModal() {
                EventBus.$emit('hideFormModal', true)
                this.resetForm()
            },
            async saveData() {
                let scope = 'user-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (this.id) {
                            this.user_form.id = this.id
                            this.updateUser(scope)
                        } else {
                            this.addUser(scope)
                        }
                    }
                });
            },
            async updateUser(scope) {
                this.showLoader = true
                let form = this.user_form
                this.$store.dispatch('updateUser', form)
                    .then((res) => {
                        this.showLoader = false
                        this.$store.dispatch('getUserSettingList')
                        this.hideFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
            async addUser(scope) {
                this.showLoader = true
                let form = this.user_form
                this.$store.dispatch('addUser', form)
                    .then((res) => {
                        this.showLoader = false
                        this.$store.dispatch('getUserSettingList')
                        this.hideFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            }
        },
		created () {
			EventBus.$on('resetForm', (val) => {
				if (val) {
					this.resetForm()
				}
			})
        }
    }
</script>